export const ENVIRO_USER_GUIDE_DEBUG_KEY = 'userGuide';
export const USER_GUIDE_DEBUG_MODE_QUERY_PARAM = 'debugMode';